import { Navigate } from "react-router-dom";
import { useContext } from "react";
import { AuthContext } from "../context/AuthContext";
import { SettingsContext } from "../context/SettingsContext";
import FullScreenLoader from "./FullScreenLoader";

export default function ProtectedRoute({ children }) {
  const { user, loading } = useContext(AuthContext);
  const { loading: settingsLoading } = useContext(SettingsContext);

  // While auth (or, once logged in, settings — theme/timezone/etc.) is
  // resolving, always show the workspace loader — never a blank screen, and
  // never mount the app shell before the correct theme is known.
  if (loading || (user && settingsLoading)) return <FullScreenLoader />;
  if (!user) return <Navigate to="/login" />;

  return children;
}
